/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowrefined2Inputs */

const en_aiflowrefined2 = /** @type {(inputs: Aiflowrefined2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done, the variant is adjusted. Anything else?`)
};

const de_aiflowrefined2 = /** @type {(inputs: Aiflowrefined2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erledigt, die Variante ist angepasst. Noch etwas?`)
};

/**
* | output |
* | --- |
* | "Done, the variant is adjusted. Anything else?" |
*
* @param {Aiflowrefined2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowrefined2 = /** @type {((inputs?: Aiflowrefined2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowrefined2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowrefined2(inputs)
	return de_aiflowrefined2(inputs)
});
export { aiflowrefined2 as "aiFlowRefined" }